(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0fc8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0fc8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iw0LO", function(module, exports) {

$parcel$export(module.exports, "ZodIssueCode", function () { return $cc88c77dfae4ccfa$export$5ba560653e4a1035; });
$parcel$export(module.exports, "ZodError", function () { return $cc88c77dfae4ccfa$export$f98dac4b251ab333; });
$parcel$export(module.exports, "string", function () { return $cc88c77dfae4ccfa$export$22b082955e083ec3; });
$parcel$export(module.exports, "object", function () { return $cc88c77dfae4ccfa$export$be5493f9613cbbe; });
$parcel$export(module.exports, "union", function () { return $cc88c77dfae4ccfa$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersection", function () { return $cc88c77dfae4ccfa$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "NEVER", function () { return $cc88c77dfae4ccfa$export$96c94437c95d7862; });
$parcel$export(module.exports, "z", function () { return $cc88c77dfae4ccfa$export$2e2bcd8739ae039; });
var $cc88c77dfae4ccfa$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($cc88c77dfae4ccfa$export$7debb50ef11d5e0b || ($cc88c77dfae4ccfa$export$7debb50ef11d5e0b = {}));
var $cc88c77dfae4ccfa$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($cc88c77dfae4ccfa$export$4aa2142c225fd5c7 || ($cc88c77dfae4ccfa$export$4aa2142c225fd5c7 = {}));
const $cc88c77dfae4ccfa$export$5716da67bfaa244d = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $cc88c77dfae4ccfa$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.undefined;
        case "string":
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $cc88c77dfae4ccfa$export$5716da67bfaa244d.nan : $cc88c77dfae4ccfa$export$5716da67bfaa244d.number;
        case "boolean":
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.boolean;
        case "function":
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.function;
        case "bigint":
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $cc88c77dfae4ccfa$export$5716da67bfaa244d.array;
            if (data === null) return $cc88c77dfae4ccfa$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $cc88c77dfae4ccfa$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $cc88c77dfae4ccfa$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $cc88c77dfae4ccfa$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $cc88c77dfae4ccfa$export$5716da67bfaa244d.date;
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.object;
        default:
            return $cc88c77dfae4ccfa$export$5716da67bfaa244d.unknown;
    }
};
const $cc88c77dfae4ccfa$export$5ba560653e4a1035 = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $cc88c77dfae4ccfa$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $cc88c77dfae4ccfa$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$cc88c77dfae4ccfa$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $cc88c77dfae4ccfa$export$f98dac4b251ab333(issues);
    return error;
};
const $cc88c77dfae4ccfa$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $cc88c77dfae4ccfa$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$cc88c77dfae4ccfa$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$cc88c77dfae4ccfa$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$cc88c77dfae4ccfa$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $cc88c77dfae4ccfa$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $cc88c77dfae4ccfa$var$overrideErrorMap = $cc88c77dfae4ccfa$export$341b0b6e0a6f5099;
function $cc88c77dfae4ccfa$export$1097a8289cfd22d7(map) {
    $cc88c77dfae4ccfa$var$overrideErrorMap = map;
}
function $cc88c77dfae4ccfa$export$32f27c719778d4c4() {
    return $cc88c77dfae4ccfa$var$overrideErrorMap;
}
const $cc88c77dfae4ccfa$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $cc88c77dfae4ccfa$export$1526d2e05f74572 = [];
function $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $cc88c77dfae4ccfa$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $cc88c77dfae4ccfa$export$32f27c719778d4c4(),
            $cc88c77dfae4ccfa$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $cc88c77dfae4ccfa$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $cc88c77dfae4ccfa$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $cc88c77dfae4ccfa$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $cc88c77dfae4ccfa$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $cc88c77dfae4ccfa$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $cc88c77dfae4ccfa$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $cc88c77dfae4ccfa$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $cc88c77dfae4ccfa$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($cc88c77dfae4ccfa$var$errorUtil || ($cc88c77dfae4ccfa$var$errorUtil = {}));
class $cc88c77dfae4ccfa$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $cc88c77dfae4ccfa$var$handleResult = (ctx, result)=>{
    if ($cc88c77dfae4ccfa$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $cc88c77dfae4ccfa$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $cc88c77dfae4ccfa$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $cc88c77dfae4ccfa$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $cc88c77dfae4ccfa$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $cc88c77dfae4ccfa$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($cc88c77dfae4ccfa$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $cc88c77dfae4ccfa$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $cc88c77dfae4ccfa$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $cc88c77dfae4ccfa$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($cc88c77dfae4ccfa$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $cc88c77dfae4ccfa$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $cc88c77dfae4ccfa$export$a60af00cc0ce2582({
            schema: this,
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $cc88c77dfae4ccfa$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $cc88c77dfae4ccfa$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $cc88c77dfae4ccfa$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $cc88c77dfae4ccfa$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $cc88c77dfae4ccfa$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $cc88c77dfae4ccfa$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $cc88c77dfae4ccfa$export$a60af00cc0ce2582({
            ...$cc88c77dfae4ccfa$var$processCreateParams(this._def),
            schema: this,
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $cc88c77dfae4ccfa$export$bb19b37874861e7e({
            ...$cc88c77dfae4ccfa$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $cc88c77dfae4ccfa$export$66b0c798a395271f({
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$cc88c77dfae4ccfa$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $cc88c77dfae4ccfa$export$75a44ec6249ac76b({
            ...$cc88c77dfae4ccfa$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $cc88c77dfae4ccfa$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $cc88c77dfae4ccfa$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $cc88c77dfae4ccfa$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $cc88c77dfae4ccfa$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $cc88c77dfae4ccfa$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $cc88c77dfae4ccfa$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $cc88c77dfae4ccfa$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $cc88c77dfae4ccfa$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $cc88c77dfae4ccfa$var$emojiRegex;
const $cc88c77dfae4ccfa$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $cc88c77dfae4ccfa$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $cc88c77dfae4ccfa$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $cc88c77dfae4ccfa$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $cc88c77dfae4ccfa$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $cc88c77dfae4ccfa$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $cc88c77dfae4ccfa$export$1230eb29b8d3b502 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const status = new $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$cc88c77dfae4ccfa$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$cc88c77dfae4ccfa$var$emojiRegex) $cc88c77dfae4ccfa$var$emojiRegex = new RegExp($cc88c77dfae4ccfa$var$_emojiRegex, "u");
                if (!$cc88c77dfae4ccfa$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$cc88c77dfae4ccfa$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$cc88c77dfae4ccfa$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$cc88c77dfae4ccfa$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$cc88c77dfae4ccfa$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $cc88c77dfae4ccfa$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$cc88c77dfae4ccfa$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_string,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $cc88c77dfae4ccfa$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$cc88c77dfae4ccfa$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $cc88c77dfae4ccfa$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $cc88c77dfae4ccfa$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $cc88c77dfae4ccfa$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $cc88c77dfae4ccfa$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$cc88c77dfae4ccfa$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $cc88c77dfae4ccfa$export$1230eb29b8d3b502({
        checks: [],
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $cc88c77dfae4ccfa$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $cc88c77dfae4ccfa$export$5b070a55c0c43e09 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$cc88c77dfae4ccfa$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($cc88c77dfae4ccfa$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $cc88c77dfae4ccfa$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $cc88c77dfae4ccfa$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$cc88c77dfae4ccfa$export$5b070a55c0c43e09.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$5b070a55c0c43e09({
        checks: [],
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$67d741fd70ff98f4 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $cc88c77dfae4ccfa$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $cc88c77dfae4ccfa$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $cc88c77dfae4ccfa$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$cc88c77dfae4ccfa$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $cc88c77dfae4ccfa$export$67d741fd70ff98f4({
        checks: [],
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$723d146f80596191 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
}
$cc88c77dfae4ccfa$export$723d146f80596191.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$723d146f80596191({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$e974be33bdc55521 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_date
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const status = new $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $cc88c77dfae4ccfa$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$cc88c77dfae4ccfa$export$e974be33bdc55521.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodDate,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$bcc3b40f6b638044 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
}
$cc88c77dfae4ccfa$export$bcc3b40f6b638044.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$bcc3b40f6b638044({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodSymbol,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$4e780e961c30340d extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
}
$cc88c77dfae4ccfa$export$4e780e961c30340d.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$4e780e961c30340d({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodUndefined,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$a96281f914484f2d extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
}
$cc88c77dfae4ccfa$export$a96281f914484f2d.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$a96281f914484f2d({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodNull,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$b9d1edb536b4e4eb extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
}
$cc88c77dfae4ccfa$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$b9d1edb536b4e4eb({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodAny,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$ef3b1bb1630977ae extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
}
$cc88c77dfae4ccfa$export$ef3b1bb1630977ae.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$ef3b1bb1630977ae({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodUnknown,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
            code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
            expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
    }
}
$cc88c77dfae4ccfa$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodNever,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$7d39f5df85f21031 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
}
$cc88c77dfae4ccfa$export$7d39f5df85f21031.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$7d39f5df85f21031({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodVoid,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$7acfc3e64785411 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.array) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big : $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $cc88c77dfae4ccfa$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $cc88c77dfae4ccfa$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $cc88c77dfae4ccfa$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$cc88c77dfae4ccfa$export$7acfc3e64785411.create = (schema, params)=>{
    return new $cc88c77dfae4ccfa$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodArray,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
function $cc88c77dfae4ccfa$var$deepPartialify(schema) {
    if (schema instanceof $cc88c77dfae4ccfa$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $cc88c77dfae4ccfa$export$aa56fec1e9d629b8.create($cc88c77dfae4ccfa$var$deepPartialify(fieldSchema));
        }
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $cc88c77dfae4ccfa$export$7acfc3e64785411) return new $cc88c77dfae4ccfa$export$7acfc3e64785411({
        ...schema._def,
        type: $cc88c77dfae4ccfa$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $cc88c77dfae4ccfa$export$aa56fec1e9d629b8) return $cc88c77dfae4ccfa$export$aa56fec1e9d629b8.create($cc88c77dfae4ccfa$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $cc88c77dfae4ccfa$export$aaac0b8b429cef5) return $cc88c77dfae4ccfa$export$aaac0b8b429cef5.create($cc88c77dfae4ccfa$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3) return $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$cc88c77dfae4ccfa$var$deepPartialify(item)));
    else return schema;
}
class $cc88c77dfae4ccfa$export$736315c5b55efbad extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                        code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $cc88c77dfae4ccfa$var$errorUtil.errToObj;
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $cc88c77dfae4ccfa$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $cc88c77dfae4ccfa$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $cc88c77dfae4ccfa$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $cc88c77dfae4ccfa$var$createZodEnum($cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$cc88c77dfae4ccfa$export$736315c5b55efbad.create = (shape, params)=>{
    return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5.create(),
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodObject,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
$cc88c77dfae4ccfa$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5.create(),
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodObject,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
$cc88c77dfae4ccfa$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $cc88c77dfae4ccfa$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5.create(),
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodObject,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$a8b236cb5070a311 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $cc88c77dfae4ccfa$export$f98dac4b251ab333(result.ctx.common.issues));
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $cc88c77dfae4ccfa$export$f98dac4b251ab333(issues));
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$cc88c77dfae4ccfa$export$a8b236cb5070a311.create = (types, params)=>{
    return new $cc88c77dfae4ccfa$export$a8b236cb5070a311({
        options: types,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodUnion,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $cc88c77dfae4ccfa$var$getDiscriminator = (type)=>{
    if (type instanceof $cc88c77dfae4ccfa$export$378d0cfce37406e6) return $cc88c77dfae4ccfa$var$getDiscriminator(type.schema);
    else if (type instanceof $cc88c77dfae4ccfa$export$a60af00cc0ce2582) return $cc88c77dfae4ccfa$var$getDiscriminator(type.innerType());
    else if (type instanceof $cc88c77dfae4ccfa$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $cc88c77dfae4ccfa$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $cc88c77dfae4ccfa$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $cc88c77dfae4ccfa$export$bb19b37874861e7e) return $cc88c77dfae4ccfa$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $cc88c77dfae4ccfa$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $cc88c77dfae4ccfa$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $cc88c77dfae4ccfa$export$5ef2424805ac76a3 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.object) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $cc88c77dfae4ccfa$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $cc88c77dfae4ccfa$export$5ef2424805ac76a3({
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$cc88c77dfae4ccfa$var$processCreateParams(params)
        });
    }
}
function $cc88c77dfae4ccfa$var$mergeValues(a, b) {
    const aType = $cc88c77dfae4ccfa$export$3e9057828ebd5c7a(a);
    const bType = $cc88c77dfae4ccfa$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.object && bType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.object) {
        const bKeys = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $cc88c77dfae4ccfa$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.array && bType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $cc88c77dfae4ccfa$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.date && bType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $cc88c77dfae4ccfa$export$c02deaf0bb5203d4 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($cc88c77dfae4ccfa$export$afa861e3c5730743(parsedLeft) || $cc88c77dfae4ccfa$export$afa861e3c5730743(parsedRight)) return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
            const merged = $cc88c77dfae4ccfa$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
            }
            if ($cc88c77dfae4ccfa$export$910b6cdd390341b3(parsedLeft) || $cc88c77dfae4ccfa$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$cc88c77dfae4ccfa$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $cc88c77dfae4ccfa$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodIntersection,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.array) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$cc88c77dfae4ccfa$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$a2acc09968cb4b7f extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.object) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $cc88c77dfae4ccfa$export$19342e026b58ebb7) return new $cc88c77dfae4ccfa$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodRecord,
            ...$cc88c77dfae4ccfa$var$processCreateParams(third)
        });
        return new $cc88c77dfae4ccfa$export$a2acc09968cb4b7f({
            keyType: $cc88c77dfae4ccfa$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodRecord,
            ...$cc88c77dfae4ccfa$var$processCreateParams(second)
        });
    }
}
class $cc88c77dfae4ccfa$export$163b6a2b712d9542 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.map) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$cc88c77dfae4ccfa$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $cc88c77dfae4ccfa$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodMap,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$977057706f816712 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.set) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $cc88c77dfae4ccfa$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $cc88c77dfae4ccfa$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $cc88c77dfae4ccfa$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $cc88c77dfae4ccfa$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$cc88c77dfae4ccfa$export$977057706f816712.create = (valueType, params)=>{
    return new $cc88c77dfae4ccfa$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodSet,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$d4602ba55673f53c extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.function) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $cc88c77dfae4ccfa$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $cc88c77dfae4ccfa$export$32f27c719778d4c4(),
                    $cc88c77dfae4ccfa$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $cc88c77dfae4ccfa$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $cc88c77dfae4ccfa$export$32f27c719778d4c4(),
                    $cc88c77dfae4ccfa$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $cc88c77dfae4ccfa$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $cc88c77dfae4ccfa$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $cc88c77dfae4ccfa$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $cc88c77dfae4ccfa$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $cc88c77dfae4ccfa$export$d4602ba55673f53c({
            ...this._def,
            args: $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3.create(items).rest($cc88c77dfae4ccfa$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $cc88c77dfae4ccfa$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $cc88c77dfae4ccfa$export$d4602ba55673f53c({
            args: args ? args : $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3.create([]).rest($cc88c77dfae4ccfa$export$ef3b1bb1630977ae.create()),
            returns: returns || $cc88c77dfae4ccfa$export$ef3b1bb1630977ae.create(),
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodFunction,
            ...$cc88c77dfae4ccfa$var$processCreateParams(params)
        });
    }
}
class $cc88c77dfae4ccfa$export$378d0cfce37406e6 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$cc88c77dfae4ccfa$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $cc88c77dfae4ccfa$export$378d0cfce37406e6({
        getter: getter,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodLazy,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$7e44096782a165d3 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$cc88c77dfae4ccfa$export$7e44096782a165d3.create = (value, params)=>{
    return new $cc88c77dfae4ccfa$export$7e44096782a165d3({
        value: value,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodLiteral,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
function $cc88c77dfae4ccfa$var$createZodEnum(values, params) {
    return new $cc88c77dfae4ccfa$export$d325d1f0e1c20179({
        values: values,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodEnum,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
}
class $cc88c77dfae4ccfa$export$d325d1f0e1c20179 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                expected: $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $cc88c77dfae4ccfa$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $cc88c77dfae4ccfa$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$cc88c77dfae4ccfa$export$d325d1f0e1c20179.create = $cc88c77dfae4ccfa$var$createZodEnum;
class $cc88c77dfae4ccfa$export$370b2e8d6d6f5c56 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.string && ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.number) {
            const expectedValues = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                expected: $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$cc88c77dfae4ccfa$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $cc88c77dfae4ccfa$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodNativeEnum,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$3f196b0127d6e50a extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$cc88c77dfae4ccfa$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $cc88c77dfae4ccfa$export$3f196b0127d6e50a({
        type: schema,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodPromise,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$a60af00cc0ce2582 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $cc88c77dfae4ccfa$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$cc88c77dfae4ccfa$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$cc88c77dfae4ccfa$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $cc88c77dfae4ccfa$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$cc88c77dfae4ccfa$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $cc88c77dfae4ccfa$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
$cc88c77dfae4ccfa$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $cc88c77dfae4ccfa$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodEffects,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$aa56fec1e9d629b8 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.undefined) return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$cc88c77dfae4ccfa$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $cc88c77dfae4ccfa$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodOptional,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$aaac0b8b429cef5 extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.null) return $cc88c77dfae4ccfa$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$cc88c77dfae4ccfa$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $cc88c77dfae4ccfa$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodNullable,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$bb19b37874861e7e extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $cc88c77dfae4ccfa$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$cc88c77dfae4ccfa$export$bb19b37874861e7e.create = (type, params)=>{
    return new $cc88c77dfae4ccfa$export$bb19b37874861e7e({
        innerType: type,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$75a44ec6249ac76b extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($cc88c77dfae4ccfa$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $cc88c77dfae4ccfa$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $cc88c77dfae4ccfa$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$cc88c77dfae4ccfa$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $cc88c77dfae4ccfa$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
class $cc88c77dfae4ccfa$export$26ccfa0145e8511f extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $cc88c77dfae4ccfa$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $cc88c77dfae4ccfa$export$db7caee60e5d514d(ctx, {
                code: $cc88c77dfae4ccfa$export$5ba560653e4a1035.invalid_type,
                expected: $cc88c77dfae4ccfa$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$cc88c77dfae4ccfa$export$26ccfa0145e8511f.create = (params)=>{
    return new $cc88c77dfae4ccfa$export$26ccfa0145e8511f({
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodNaN,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
const $cc88c77dfae4ccfa$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $cc88c77dfae4ccfa$export$66b0c798a395271f extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $cc88c77dfae4ccfa$export$a3c3ef8a0e95c6da extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $cc88c77dfae4ccfa$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $cc88c77dfae4ccfa$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $cc88c77dfae4ccfa$export$5d1f7ef05c4e493a extends $cc88c77dfae4ccfa$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($cc88c77dfae4ccfa$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$cc88c77dfae4ccfa$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $cc88c77dfae4ccfa$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $cc88c77dfae4ccfa$export$558106ce543bd011.ZodReadonly,
        ...$cc88c77dfae4ccfa$var$processCreateParams(params)
    });
};
const $cc88c77dfae4ccfa$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $cc88c77dfae4ccfa$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $cc88c77dfae4ccfa$export$b9d1edb536b4e4eb.create();
};
const $cc88c77dfae4ccfa$export$1ee8ee30835eab8b = {
    object: $cc88c77dfae4ccfa$export$736315c5b55efbad.lazycreate
};
var $cc88c77dfae4ccfa$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($cc88c77dfae4ccfa$export$558106ce543bd011 || ($cc88c77dfae4ccfa$export$558106ce543bd011 = {}));
const $cc88c77dfae4ccfa$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$cc88c77dfae4ccfa$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $cc88c77dfae4ccfa$export$22b082955e083ec3 = $cc88c77dfae4ccfa$export$1230eb29b8d3b502.create;
const $cc88c77dfae4ccfa$export$98e628dec113755e = $cc88c77dfae4ccfa$export$5b070a55c0c43e09.create;
const $cc88c77dfae4ccfa$export$9e06de0973666692 = $cc88c77dfae4ccfa$export$26ccfa0145e8511f.create;
const $cc88c77dfae4ccfa$export$a0f65b52274bcc00 = $cc88c77dfae4ccfa$export$67d741fd70ff98f4.create;
const $cc88c77dfae4ccfa$export$4a21f16c33752377 = $cc88c77dfae4ccfa$export$723d146f80596191.create;
const $cc88c77dfae4ccfa$export$324d90190a8b822a = $cc88c77dfae4ccfa$export$e974be33bdc55521.create;
const $cc88c77dfae4ccfa$export$8f701197936bc2a6 = $cc88c77dfae4ccfa$export$bcc3b40f6b638044.create;
const $cc88c77dfae4ccfa$export$1db45310990710a5 = $cc88c77dfae4ccfa$export$4e780e961c30340d.create;
const $cc88c77dfae4ccfa$export$7b1b591b262c240 = $cc88c77dfae4ccfa$export$a96281f914484f2d.create;
const $cc88c77dfae4ccfa$export$4154a199d7d90455 = $cc88c77dfae4ccfa$export$b9d1edb536b4e4eb.create;
const $cc88c77dfae4ccfa$export$19282c40b967aec6 = $cc88c77dfae4ccfa$export$ef3b1bb1630977ae.create;
const $cc88c77dfae4ccfa$export$b3e22bcfd64c1022 = $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5.create;
const $cc88c77dfae4ccfa$export$490e536ee7389aeb = $cc88c77dfae4ccfa$export$7d39f5df85f21031.create;
const $cc88c77dfae4ccfa$export$2f23118c22fb2630 = $cc88c77dfae4ccfa$export$7acfc3e64785411.create;
const $cc88c77dfae4ccfa$export$be5493f9613cbbe = $cc88c77dfae4ccfa$export$736315c5b55efbad.create;
const $cc88c77dfae4ccfa$export$8fb0df5f40d0b477 = $cc88c77dfae4ccfa$export$736315c5b55efbad.strictCreate;
const $cc88c77dfae4ccfa$export$971dd5b0dfd021b6 = $cc88c77dfae4ccfa$export$a8b236cb5070a311.create;
const $cc88c77dfae4ccfa$export$4b888e40c4ee26dd = $cc88c77dfae4ccfa$export$5ef2424805ac76a3.create;
const $cc88c77dfae4ccfa$export$bc86dfbf7795668c = $cc88c77dfae4ccfa$export$c02deaf0bb5203d4.create;
const $cc88c77dfae4ccfa$export$65e3907585753458 = $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3.create;
const $cc88c77dfae4ccfa$export$e5185e241753e543 = $cc88c77dfae4ccfa$export$a2acc09968cb4b7f.create;
const $cc88c77dfae4ccfa$export$871de8747c9eaa88 = $cc88c77dfae4ccfa$export$163b6a2b712d9542.create;
const $cc88c77dfae4ccfa$export$adaa4cf7ef1b65be = $cc88c77dfae4ccfa$export$977057706f816712.create;
const $cc88c77dfae4ccfa$export$44e51c8aac7c2deb = $cc88c77dfae4ccfa$export$d4602ba55673f53c.create;
const $cc88c77dfae4ccfa$export$488013bae63b21da = $cc88c77dfae4ccfa$export$378d0cfce37406e6.create;
const $cc88c77dfae4ccfa$export$c8ec6e1ec9fefcb0 = $cc88c77dfae4ccfa$export$7e44096782a165d3.create;
const $cc88c77dfae4ccfa$export$78a99c8d44d72635 = $cc88c77dfae4ccfa$export$d325d1f0e1c20179.create;
const $cc88c77dfae4ccfa$export$6fe7eca19ebe5199 = $cc88c77dfae4ccfa$export$370b2e8d6d6f5c56.create;
const $cc88c77dfae4ccfa$export$c957ef27a0ebfd4 = $cc88c77dfae4ccfa$export$3f196b0127d6e50a.create;
const $cc88c77dfae4ccfa$export$dc573d8a6576cdb3 = $cc88c77dfae4ccfa$export$a60af00cc0ce2582.create;
const $cc88c77dfae4ccfa$export$516e28dec6a4b6d4 = $cc88c77dfae4ccfa$export$aa56fec1e9d629b8.create;
const $cc88c77dfae4ccfa$export$133fc36489ac9add = $cc88c77dfae4ccfa$export$aaac0b8b429cef5.create;
const $cc88c77dfae4ccfa$export$fc37fe19dfda43ee = $cc88c77dfae4ccfa$export$a60af00cc0ce2582.createWithPreprocess;
const $cc88c77dfae4ccfa$export$43f28b24e1eb8181 = $cc88c77dfae4ccfa$export$a3c3ef8a0e95c6da.create;
const $cc88c77dfae4ccfa$export$3b3d07727c5b702c = ()=>$cc88c77dfae4ccfa$export$22b082955e083ec3().optional();
const $cc88c77dfae4ccfa$export$eb150471a61fced6 = ()=>$cc88c77dfae4ccfa$export$98e628dec113755e().optional();
const $cc88c77dfae4ccfa$export$269251733cdcbbf1 = ()=>$cc88c77dfae4ccfa$export$4a21f16c33752377().optional();
const $cc88c77dfae4ccfa$export$8c14e57e778d3873 = {
    string: (arg)=>$cc88c77dfae4ccfa$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$cc88c77dfae4ccfa$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$cc88c77dfae4ccfa$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$cc88c77dfae4ccfa$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$cc88c77dfae4ccfa$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $cc88c77dfae4ccfa$export$96c94437c95d7862 = $cc88c77dfae4ccfa$export$9a105a556e65c2c0;
var $cc88c77dfae4ccfa$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $cc88c77dfae4ccfa$export$341b0b6e0a6f5099,
    setErrorMap: $cc88c77dfae4ccfa$export$1097a8289cfd22d7,
    getErrorMap: $cc88c77dfae4ccfa$export$32f27c719778d4c4,
    makeIssue: $cc88c77dfae4ccfa$export$244a85fde9c419ed,
    EMPTY_PATH: $cc88c77dfae4ccfa$export$1526d2e05f74572,
    addIssueToContext: $cc88c77dfae4ccfa$export$db7caee60e5d514d,
    ParseStatus: $cc88c77dfae4ccfa$export$5b20a5c3d05c1f6f,
    INVALID: $cc88c77dfae4ccfa$export$9a105a556e65c2c0,
    DIRTY: $cc88c77dfae4ccfa$export$325a211da9693fcf,
    OK: $cc88c77dfae4ccfa$export$c6813a8d51f77eaf,
    isAborted: $cc88c77dfae4ccfa$export$afa861e3c5730743,
    isDirty: $cc88c77dfae4ccfa$export$910b6cdd390341b3,
    isValid: $cc88c77dfae4ccfa$export$1ea939691cdc45b8,
    isAsync: $cc88c77dfae4ccfa$export$aefee5ebe1dcfd9e,
    get util () {
        return $cc88c77dfae4ccfa$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $cc88c77dfae4ccfa$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $cc88c77dfae4ccfa$export$5716da67bfaa244d,
    getParsedType: $cc88c77dfae4ccfa$export$3e9057828ebd5c7a,
    ZodType: $cc88c77dfae4ccfa$export$19342e026b58ebb7,
    ZodString: $cc88c77dfae4ccfa$export$1230eb29b8d3b502,
    ZodNumber: $cc88c77dfae4ccfa$export$5b070a55c0c43e09,
    ZodBigInt: $cc88c77dfae4ccfa$export$67d741fd70ff98f4,
    ZodBoolean: $cc88c77dfae4ccfa$export$723d146f80596191,
    ZodDate: $cc88c77dfae4ccfa$export$e974be33bdc55521,
    ZodSymbol: $cc88c77dfae4ccfa$export$bcc3b40f6b638044,
    ZodUndefined: $cc88c77dfae4ccfa$export$4e780e961c30340d,
    ZodNull: $cc88c77dfae4ccfa$export$a96281f914484f2d,
    ZodAny: $cc88c77dfae4ccfa$export$b9d1edb536b4e4eb,
    ZodUnknown: $cc88c77dfae4ccfa$export$ef3b1bb1630977ae,
    ZodNever: $cc88c77dfae4ccfa$export$1e576a20c3ce9fb5,
    ZodVoid: $cc88c77dfae4ccfa$export$7d39f5df85f21031,
    ZodArray: $cc88c77dfae4ccfa$export$7acfc3e64785411,
    ZodObject: $cc88c77dfae4ccfa$export$736315c5b55efbad,
    ZodUnion: $cc88c77dfae4ccfa$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $cc88c77dfae4ccfa$export$5ef2424805ac76a3,
    ZodIntersection: $cc88c77dfae4ccfa$export$c02deaf0bb5203d4,
    ZodTuple: $cc88c77dfae4ccfa$export$e2a18bb771d8e6a3,
    ZodRecord: $cc88c77dfae4ccfa$export$a2acc09968cb4b7f,
    ZodMap: $cc88c77dfae4ccfa$export$163b6a2b712d9542,
    ZodSet: $cc88c77dfae4ccfa$export$977057706f816712,
    ZodFunction: $cc88c77dfae4ccfa$export$d4602ba55673f53c,
    ZodLazy: $cc88c77dfae4ccfa$export$378d0cfce37406e6,
    ZodLiteral: $cc88c77dfae4ccfa$export$7e44096782a165d3,
    ZodEnum: $cc88c77dfae4ccfa$export$d325d1f0e1c20179,
    ZodNativeEnum: $cc88c77dfae4ccfa$export$370b2e8d6d6f5c56,
    ZodPromise: $cc88c77dfae4ccfa$export$3f196b0127d6e50a,
    ZodEffects: $cc88c77dfae4ccfa$export$a60af00cc0ce2582,
    ZodTransformer: $cc88c77dfae4ccfa$export$a60af00cc0ce2582,
    ZodOptional: $cc88c77dfae4ccfa$export$aa56fec1e9d629b8,
    ZodNullable: $cc88c77dfae4ccfa$export$aaac0b8b429cef5,
    ZodDefault: $cc88c77dfae4ccfa$export$bb19b37874861e7e,
    ZodCatch: $cc88c77dfae4ccfa$export$75a44ec6249ac76b,
    ZodNaN: $cc88c77dfae4ccfa$export$26ccfa0145e8511f,
    BRAND: $cc88c77dfae4ccfa$export$cf2deea74cde46b4,
    ZodBranded: $cc88c77dfae4ccfa$export$66b0c798a395271f,
    ZodPipeline: $cc88c77dfae4ccfa$export$a3c3ef8a0e95c6da,
    ZodReadonly: $cc88c77dfae4ccfa$export$5d1f7ef05c4e493a,
    custom: $cc88c77dfae4ccfa$export$4c00f665f0d4b443,
    Schema: $cc88c77dfae4ccfa$export$19342e026b58ebb7,
    ZodSchema: $cc88c77dfae4ccfa$export$19342e026b58ebb7,
    late: $cc88c77dfae4ccfa$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $cc88c77dfae4ccfa$export$558106ce543bd011;
    },
    coerce: $cc88c77dfae4ccfa$export$8c14e57e778d3873,
    any: $cc88c77dfae4ccfa$export$4154a199d7d90455,
    array: $cc88c77dfae4ccfa$export$2f23118c22fb2630,
    bigint: $cc88c77dfae4ccfa$export$a0f65b52274bcc00,
    boolean: $cc88c77dfae4ccfa$export$4a21f16c33752377,
    date: $cc88c77dfae4ccfa$export$324d90190a8b822a,
    discriminatedUnion: $cc88c77dfae4ccfa$export$4b888e40c4ee26dd,
    effect: $cc88c77dfae4ccfa$export$dc573d8a6576cdb3,
    "enum": $cc88c77dfae4ccfa$export$78a99c8d44d72635,
    "function": $cc88c77dfae4ccfa$export$44e51c8aac7c2deb,
    "instanceof": $cc88c77dfae4ccfa$export$3d916e7c22dbd8b5,
    intersection: $cc88c77dfae4ccfa$export$bc86dfbf7795668c,
    lazy: $cc88c77dfae4ccfa$export$488013bae63b21da,
    literal: $cc88c77dfae4ccfa$export$c8ec6e1ec9fefcb0,
    map: $cc88c77dfae4ccfa$export$871de8747c9eaa88,
    nan: $cc88c77dfae4ccfa$export$9e06de0973666692,
    nativeEnum: $cc88c77dfae4ccfa$export$6fe7eca19ebe5199,
    never: $cc88c77dfae4ccfa$export$b3e22bcfd64c1022,
    "null": $cc88c77dfae4ccfa$export$7b1b591b262c240,
    nullable: $cc88c77dfae4ccfa$export$133fc36489ac9add,
    number: $cc88c77dfae4ccfa$export$98e628dec113755e,
    object: $cc88c77dfae4ccfa$export$be5493f9613cbbe,
    oboolean: $cc88c77dfae4ccfa$export$269251733cdcbbf1,
    onumber: $cc88c77dfae4ccfa$export$eb150471a61fced6,
    optional: $cc88c77dfae4ccfa$export$516e28dec6a4b6d4,
    ostring: $cc88c77dfae4ccfa$export$3b3d07727c5b702c,
    pipeline: $cc88c77dfae4ccfa$export$43f28b24e1eb8181,
    preprocess: $cc88c77dfae4ccfa$export$fc37fe19dfda43ee,
    promise: $cc88c77dfae4ccfa$export$c957ef27a0ebfd4,
    record: $cc88c77dfae4ccfa$export$e5185e241753e543,
    set: $cc88c77dfae4ccfa$export$adaa4cf7ef1b65be,
    strictObject: $cc88c77dfae4ccfa$export$8fb0df5f40d0b477,
    string: $cc88c77dfae4ccfa$export$22b082955e083ec3,
    symbol: $cc88c77dfae4ccfa$export$8f701197936bc2a6,
    transformer: $cc88c77dfae4ccfa$export$dc573d8a6576cdb3,
    tuple: $cc88c77dfae4ccfa$export$65e3907585753458,
    "undefined": $cc88c77dfae4ccfa$export$1db45310990710a5,
    union: $cc88c77dfae4ccfa$export$971dd5b0dfd021b6,
    unknown: $cc88c77dfae4ccfa$export$19282c40b967aec6,
    "void": $cc88c77dfae4ccfa$export$490e536ee7389aeb,
    NEVER: $cc88c77dfae4ccfa$export$96c94437c95d7862,
    ZodIssueCode: $cc88c77dfae4ccfa$export$5ba560653e4a1035,
    quotelessJson: $cc88c77dfae4ccfa$export$913eddeaf297cfea,
    ZodError: $cc88c77dfae4ccfa$export$f98dac4b251ab333
});

});

})();
//# sourceMappingURL=activate.fab31234.js.map
